var _path, _path2, _ellipse, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 7.15C3.66969 7.15 3.26675 6.74706 3.26675 6.25C3.26675 5.75294 3.66969 5.35 4.16675 5.35V7.15ZM11.6667 5.35C12.1638 5.35 12.5667 5.75294 12.5667 6.25C12.5667 6.74706 12.1638 7.15 11.6667 7.15V5.35ZM4.16675 5.35H11.6667V7.15H4.16675V5.35Z",
    fill: "#080134"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 14.65C7.8362 14.65 7.43325 14.2471 7.43325 13.75C7.43325 13.2529 7.8362 12.85 8.33325 12.85V14.65ZM15.8333 12.85C16.3303 12.85 16.7333 13.2529 16.7333 13.75C16.7333 14.2471 16.3303 14.65 15.8333 14.65V12.85ZM8.33325 12.85H15.8333V14.65H8.33325V12.85Z",
    fill: "#080134"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.33333,
    ry: 3.33333,
    transform: "matrix(-1 0 0 1 14.9999 6.24984)",
    stroke: "#080134",
    strokeWidth: 1.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3.33333,
    transform: "matrix(-1 0 0 1 4.99992 13.7498)",
    stroke: "#080134",
    strokeWidth: 1.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.cca7817e.svg";
export { ForwardRef as ReactComponent };